export default "__VITE_PUBLIC_ASSET__efe02da0__"